const arrow__back = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  paddingLeft: '16px',
  paddingTop: '4px',
  color: '#F0DB4F',
  cursor: 'pointer',
}

export { arrow__back };